import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

import EmailIcon from '../../assets/icons/Emails, Letter, Mail.png';
import AuthWrapper from '../../common/AuthWrapper';
import CustomSocialMediaButton from '../../common/CustomSocialMediaButton';
import { useIsMobile } from '../../hooks/useWindowWidth';
import GoogleButton from '../../common/GoogleButton/GoogleButton';
import { isInviteFlowEnabled } from '../../constants/inviteFlow';

import styles from './SignIn.module.scss';

const SignIn: FC = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const isInviteFlow = isInviteFlowEnabled();

  return (
    <AuthWrapper btnName="Sign Up">
      <Box className={styles.signInContent}>
        <Typography
          variant={`${isMobile ? 'h6Bold' : 'h5Bold'}`}
          className={styles.title}
        >
          Login
        </Typography>
        <CustomSocialMediaButton
          customStyle={styles.emailButton}
          text="Continue with Email"
          icon={EmailIcon}
          onClick={() => navigate('/login')}
        />
        {!isInviteFlow && (
          <>
            <Box className={styles.signInText}>
              <Box className={styles.dividerLine}></Box>
              <Typography
                variant="h12"
                className={styles.dividerText}
              >
                OR
              </Typography>
              <Box className={styles.dividerLine}></Box>
            </Box>
            <Box className={styles.socialMediaButtons}>
              <GoogleButton />
            </Box>
          </>
        )}
        <Box className={styles.signUpQuestion}>
          <Typography
            variant="h11"
            className={styles.signUpQuestionText}
          >
            Don't have an account?
          </Typography>
          <Link
            to="/sign-up"
            className={styles.signUpLink}
          >
            <Typography variant="h11Semibold">Sign Up</Typography>
          </Link>
        </Box>
      </Box>
    </AuthWrapper>
  );
};

export default SignIn;
